import { render } from "./NcTextarea.vue?vue&type=template&id=7596a646"
import script from "./NcTextarea.vue?vue&type=script&lang=js"
export * from "./NcTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__